import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Grid,
  Box,
  Typography,
  AppBar,
  Toolbar,
} from "@mui/material";
import { Add, Close } from "@mui/icons-material";
import BackWithArrow from "../../common/BackWithArrow";
//import { Plus } from "lucide-react";
import PluseIconDesign from "../../common/PluseIconDesign";
import SaveIcon from "@mui/icons-material/Save";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

export default function NewEquipmentButton() {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    type: "",
    department: "",
    description: "",
    manufacturer: "",
    model: "",
    serialNumber: "",
    calibrationDate: "",
  });

  const handleChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };

  const handleSubmit = () => {
    console.log("New Equipment Data:", formData);
    setOpen(false);
  };

  return (
    <>
      <PluseIconDesign
        variant="contained"
        sx={{
          backgroundColor: "#4F46E5",
          "&:hover": { backgroundColor: "#4338CA" },
        }}
        startIcon={<Add />}
        onClick={() => setOpen(true)}
      />

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullScreen
        PaperProps={{
          sx: {
            minHeight: "100vh",
            maxHeight: "100vh",
            background: "white",
          },
        }}
      >
        <BackWithArrow onBack={() => setOpen(false)} />
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Equipment Name"
                  value={formData.name}
                  onChange={handleChange("name")}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Type"
                  value={formData.type}
                  onChange={handleChange("type")}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Department"
                  value={formData.department}
                  onChange={handleChange("department")}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Manufacturer"
                  value={formData.manufacturer}
                  onChange={handleChange("manufacturer")}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Model"
                  value={formData.model}
                  onChange={handleChange("model")}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Serial Number"
                  value={formData.serialNumber}
                  onChange={handleChange("serialNumber")}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Calibration Date"
                  type="date"
                  value={formData.calibrationDate}
                  onChange={handleChange("calibrationDate")}
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Description"
                  value={formData.description}
                  onChange={handleChange("description")}
                  variant="outlined"
                  multiline
                  rows={4}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            variant="contained"
            onClick={() => setOpen(false)}
            sx={{
              backgroundColor: "#FFFFFF",
              color: "#4F46E5",
              "&:hover": {
                backgroundColor: "#4F46E5",
                color: "#FFFFFF",
              },
            }}
            startIcon={<RestartAltIcon color="#4F46E5" />}
          >
            Reset
          </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#4F46E5",
              color: "#FFFFFF",
              borderRadius: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "&:hover": {
                backgroundColor: "#fff",
                "& .icon": {
                  color: "#4F46E5", // icon color matches border on hover
                },
                color: "#4F46E5",
              },
            }}
            onClick={handleSubmit}
            startIcon={<SaveIcon />}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
